var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgNotificationsFill = function SvgNotificationsFill(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "notifications_fill_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#notifications_fill_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M3.25 10a.713.713 0 0 1-.535-.223.634.634 0 0 1-.184-.527c.09-1.12.37-2.19.838-3.21a9.501 9.501 0 0 1 1.885-2.732.725.725 0 0 1 .522-.213.732.732 0 0 1 .547.228c.139.139.21.307.213.507a.758.758 0 0 1-.213.537 8.264 8.264 0 0 0-1.58 2.246A7.594 7.594 0 0 0 4.03 9.25a.847.847 0 0 1-.246.535.726.726 0 0 1-.535.215Zm17.5 0a.733.733 0 0 1-.527-.215.83.83 0 0 1-.254-.535 7.612 7.612 0 0 0-.707-2.633 8.204 8.204 0 0 0-1.575-2.24.812.812 0 0 1-.218-.547c0-.2.078-.372.233-.517a.724.724 0 0 1 .53-.223c.204 0 .376.07.514.208a9.482 9.482 0 0 1 1.885 2.737 9.543 9.543 0 0 1 .838 3.215.634.634 0 0 1-.184.527.713.713 0 0 1-.535.223ZM5 18.865a.726.726 0 0 1-.535-.215.726.726 0 0 1-.215-.535c0-.212.072-.39.215-.534A.726.726 0 0 1 5 17.365h1.25v-7.25A5.63 5.63 0 0 1 7.5 6.534c.833-1.056 1.917-1.731 3.25-2.026v-.7c0-.353.12-.65.36-.89.241-.24.538-.36.89-.36.353 0 .65.12.89.36s.36.537.36.89v.7c1.333.295 2.417.97 3.25 2.026a5.63 5.63 0 0 1 1.25 3.581v7.25H19c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534.726.726 0 0 1-.215.535.726.726 0 0 1-.535.215H5Zm7 2.943c-.492 0-.917-.175-1.273-.525A1.73 1.73 0 0 1 10.192 20h3.616c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525Z",
    fill: "currentColor"
  }))));
};
export default SvgNotificationsFill;